"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_ACTIVITY_TYPE_MAP = exports.MATCH_RESULT_TYPE_MAP = exports.RELATIONSHIP_TYPE_MAP = exports.URL_CATEGORY_MAP = exports.GENDER_MAP = exports.PHONE_TYPE_MAP = exports.EMAIL_TYPE_MAP = exports.ADDRESS_TYPE_MAP = exports.NAME_TYPE_MAP = exports.CONTRACT_STATUS_MAP = exports.USER_STATUS_MAP = exports.USER_ROLE_MAP = void 0;
// mapping between graphql enums and TS union types
var invert_1 = __importDefault(require("lodash/invert"));
var USER_ROLE = {
    user: 'USER',
    admin: 'ADMIN',
    organizationAdmin: 'ORGANIZATION_ADMIN',
};
exports.USER_ROLE_MAP = __assign(__assign({}, USER_ROLE), (0, invert_1.default)(USER_ROLE));
var USER_STATUS = {
    pending: 'PENDING',
    active: 'ACTIVE',
};
exports.USER_STATUS_MAP = __assign(__assign({}, USER_STATUS), (0, invert_1.default)(USER_STATUS));
var CONTRACT_STATUS = {
    pending: 'PENDING',
    active: 'ACTIVE',
    expired: 'EXPIRED',
};
exports.CONTRACT_STATUS_MAP = __assign(__assign({}, CONTRACT_STATUS), (0, invert_1.default)(CONTRACT_STATUS));
var NAME_TYPE = {
    present: 'PRESENT',
    maiden: 'MAIDEN',
    former: 'FORMER',
    alias: 'ALIAS',
};
exports.NAME_TYPE_MAP = __assign(__assign({}, NAME_TYPE), (0, invert_1.default)(NAME_TYPE));
var ADDRESS_TYPE = {
    work: 'WORK',
    home: 'HOME',
    old: 'OLD',
};
exports.ADDRESS_TYPE_MAP = __assign(__assign({}, ADDRESS_TYPE), (0, invert_1.default)(ADDRESS_TYPE));
var EMAIL_TYPE = {
    personal: 'PERSONAL',
    work: 'WORK',
};
exports.EMAIL_TYPE_MAP = __assign(__assign({}, EMAIL_TYPE), (0, invert_1.default)(EMAIL_TYPE));
var PHONE_TYPE = {
    mobile: 'MOBILE',
    homePhone: 'HOME_PHONE',
    homeFax: 'HOME_FAX',
    workPhone: 'WORK_PHONE',
    workFax: 'WORK_FAX',
    pager: 'PAGER',
};
exports.PHONE_TYPE_MAP = __assign(__assign({}, PHONE_TYPE), (0, invert_1.default)(PHONE_TYPE));
var GENDER = {
    male: 'MALE',
    female: 'FEMALE',
};
exports.GENDER_MAP = __assign(__assign({}, GENDER), (0, invert_1.default)(GENDER));
var URL_CATEGORY = {
    backgroundReports: 'BACKGROUND_REPORTS',
    contactDetails: 'CONTACT_DETAILS',
    emailAddress: 'EMAIL_ADDRESS',
    media: 'MEDIA',
    personalProfiles: 'PERSONAL_PROFILES',
    professionalAndBusiness: 'PROFESSIONAL_AND_BUSINESS',
    publicRecords: 'PUBLIC_RECORDS',
    publications: 'PUBLICATIONS',
    schoolAndClassmates: 'SCHOOL_AND_CLASSMATES',
    webpages: 'WEBPAGES',
};
exports.URL_CATEGORY_MAP = __assign(__assign({}, URL_CATEGORY), (0, invert_1.default)(URL_CATEGORY));
var RELATIONSHIP_TYPE = {
    work: 'WORK',
    family: 'FAMILY',
    friend: 'FRIEND',
    other: 'OTHER',
};
exports.RELATIONSHIP_TYPE_MAP = __assign(__assign({}, RELATIONSHIP_TYPE), (0, invert_1.default)(RELATIONSHIP_TYPE));
var MATCH_RESULT_TYPE = {
    match: 'MATCH',
    noMatch: 'NO_MATCH',
    error: 'ERROR',
};
exports.MATCH_RESULT_TYPE_MAP = __assign(__assign({}, MATCH_RESULT_TYPE), (0, invert_1.default)(MATCH_RESULT_TYPE));
var SEARCH_ACTIVITY_TYPE = {
    search: 'SEARCH',
    profile: 'PROFILE',
};
exports.SEARCH_ACTIVITY_TYPE_MAP = __assign(__assign({}, SEARCH_ACTIVITY_TYPE), (0, invert_1.default)(SEARCH_ACTIVITY_TYPE));
//# sourceMappingURL=maps.js.map